module.exports = __webpack_public_path__ + "img/268.0c0040da.png";